const classes = {
  barbarian: "Barbarian",
  crusader: "Crusader",
  "demon-hunter": "Demon Hunter",
  monk: "Monk",
  necromancer: "Necromancer",
  "witch-doctor": "Witch Doctor",
  wizard: "Wizard"
};

export default classes;
